import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Button, Tag } from "@gemini/ui";
import { useMediaOverlay } from "./useMediaOverlay";
export const MediaOverlay = ({ media, onClick }) => {
    const { t } = useI18n();
    const { tagIcon, tagText, buttonIcon } = useMediaOverlay(media);
    return (_jsxs(_Fragment, { children: [_jsx(Tag, { position: "absolute", bottom: "spacing.12", left: "spacing.12", zIndex: "zIndex.1", icon: tagIcon, variant: "dark", children: tagText }), _jsx(Box, { position: "absolute", top: "50%", left: "50%", zIndex: "zIndex.1", transform: "translate(-50%, -50%)", children: _jsx(Button, { iconOnly: true, size: "40", icon: buttonIcon, variant: "secondary-floating", onPress: onClick, children: t("richMedia.preview.cta") }) })] }));
};
